// extracted by mini-css-extract-plugin
export default {"outer_wrapper":"Main_outer_wrapper__8Uo5-","footer_row":"Main_footer_row__nN8OC"};